import { create } from 'zustand';

type AuthorizationStore = {
  token: string | null;
};

/**
 * Authorization store contains the latest jwt
 */
export const useAuthorizationStore = create<AuthorizationStore>(() => ({
  token: null,
}));
